import { render, staticRenderFns } from "./OctMenuItemGroup.vue?vue&type=template&id=07bbd7b1&scoped=true&"
import script from "./OctMenuItemGroup.vue?vue&type=script&lang=js&"
export * from "./OctMenuItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./OctMenuItemGroup.vue?vue&type=style&index=0&id=07bbd7b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbd7b1",
  null
  
)

export default component.exports